import {SchemeLink} from '../../../../applink/SchemeLink';
import {Icon} from '../../../../design-system/atoms/Icon/Icon';
import {IconType} from '../../../../design-system/atoms/Icon/IconType.enum';
import {Text} from '../../../../design-system/atoms/Text/Text';
import {ConditionalWrapper} from '../../../../design-system/organisms/ConditionalWrapper/ConditionalWrapper';
import {BannerItem as BannerItemType} from '../../../../graphql/generated/types';
import {CommonItemProps} from '../../type';

export function OnAir({item}: CommonItemProps) {
  const {videoUrl, title, caption, scheme} = item as BannerItemType;

  if (!videoUrl) return null;
  const embeddedSrc = SHORT_REGEX.test(videoUrl)
    ? videoUrl.replace(SHORT_REGEX, `${REPLACE_PREFIX}/livelink$1`)
    : NORMAL_REGEX.test(videoUrl)
      ? videoUrl.replace(NORMAL_REGEX, `${REPLACE_PREFIX}$1`)
      : videoUrl;
  const isValidUrl = embeddedSrc.includes(VALID_URL);
  const isPlayerEventScheme =
    !!scheme && scheme.startsWith('kakaopage://open/video_playground');
  // TODO: TvPlayer.tsx 내의 /api/v1/inven/increase_vod_count 요청 부분이 NEXT 에 유지되는지 확인 후 구현
  if (!isValidUrl) {
    return null;
  }
  const queryparam = 'service=kakao_page&rel=0&autoplay=1&mute=1';

  return (
    <div className="isolate flex w-full flex-col overflow-hidden rounded-16pxr">
      <div className="relative w-full pt-[56.25%]">
        <iframe
          width={'100%'}
          height={'100%'}
          className="absolute inset-0 h-full w-full overflow-hidden"
          src={`${embeddedSrc}?${queryparam}`}
          frameBorder={0}
          scrolling="no"
          allowFullScreen
        />
      </div>

      <ConditionalWrapper
        condition={!isPlayerEventScheme}
        WrapperComponent={SchemeLink}
        wrapperProps={{scheme, linkClassName: 'cursor-pointer'}}
      >
        <div
          className={
            'h-72px flex-col items-start bg-theme-solid-10 py-14px px-15px'
          }
        >
          <div>
            <Text className="font-medium2 text-theme-solid-100">{title}</Text>
          </div>
          <div className="mt-8px flex">
            {scheme && (
              <Icon type={IconType.BadgeOnairStatic} disableActiveEffect />
            )}
            <Text className="font-small2 ml-6px text-theme-solid-60">
              {caption}
            </Text>
          </div>
        </div>
      </ConditionalWrapper>
    </div>
  );
}

const SHORT_REGEX = /\/l(\/\d+).*/i;
const NORMAL_REGEX = /\/channel\/\d+(\/(livelink|cliplink)\/[^?]*)/i;
const REPLACE_PREFIX = '/embed/player';
const VALID_URL = 'tv.kakao.com/embed/player';
